export default __webpack_public_path__ + "static/1268-b7be9ac73655b01aff1f2714e868c3a8.gif";